import React, { FC } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import router from '~/core/router';
import AuthRoute from '~/route/AuthRoute';
import PrivateRoute from '~/route/PrivateRoute';
import UnAuthorizedRoute from '~/route/UnAuthorizedRoute';

import {
  ExtensionOffboardingOldPath,
  ExtensionOffboardingPath,
  ExtensionOnboardingOldPath,
  ExtensionOnboardingPath,
} from './modules/extension/constants';

const authRoutes = router.getAuthRoutes();
const privateRoutes = router.getPrivateRoutes();
const unAuthorizedRoutes = router.getUnAuthorizedRoutes();

const redirects = [
  { from: ExtensionOnboardingOldPath, to: ExtensionOnboardingPath },
  { from: ExtensionOffboardingOldPath, to: ExtensionOffboardingPath },
];

const Router: FC = () => {
  return (
    <Routes>
      {authRoutes.map(({ path, Component }) => (
        <Route
          key={path}
          path={path}
          element={<AuthRoute Component={Component} />}
        />
      ))}
      {privateRoutes.map(({ path, Component, checkAvailability }) => (
        <Route
          key={path}
          path={path}
          element={
            <PrivateRoute
              Component={Component}
              checkAvailability={checkAvailability}
            />
          }
        />
      ))}
      {unAuthorizedRoutes.map(({ path, Component, checkAvailability }) => (
        <Route
          key={path}
          path={path}
          element={
            <UnAuthorizedRoute
              Component={Component}
              checkAvailability={checkAvailability}
            />
          }
        />
      ))}
      {redirects.map(({ from, to }) => (
        <Route key={from} path={from} element={<Navigate to={to} />} />
      ))}
      <Route path="*" element={<Navigate to={router.getSignInRoutePath()} />} />
    </Routes>
  );
};

export default Router;
